import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';
import { CreateBlackListItem } from "../api/types/blacklist";

initDefaultSchema();

// Create
export type CreateBlackListItemFormT = CreateBlackListItem['request'];

export const getCreateBlackListItemValues = ()
  : CreateBlackListItemFormT => ({
    telegram_id: 0,
  });
const createActorSettingSchema: Yup.ObjectSchema<CreateBlackListItemFormT> = Yup.object({
  telegram_id: Yup.number().required(),
});
export const createBlackListItemResolver = yupResolver(createActorSettingSchema) as Resolver<CreateBlackListItemFormT>;
